import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DatePicker } from "@/components/DatePicker";
import { IST_TZ } from "@/lib/utils";

export const PERIODS = [
  ["all", "Till date"], ["today", "Today"], ["yesterday", "Yesterday"], ["this_week", "This week"],
  ["last_week", "Last week"], ["this_month", "This month"], ["last_month", "Last month"], ["custom", "Custom range"],
];

const istToday = () => {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: IST_TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
  const [y, m, d] = parts.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d));
};
const iso = (d) => d.toISOString().slice(0, 10);
const shift = (d, days) => new Date(d.getTime() + days * 86400000);

// Returns { from, to } as YYYY-MM-DD in IST calendar days (weeks start Monday).
export function periodRange(period, custom = {}) {
  const t = istToday();
  const dow = (t.getUTCDay() + 6) % 7;
  const monday = shift(t, -dow);
  const firstOfMonth = new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), 1));
  switch (period) {
    case "today": return { from: iso(t), to: iso(t) };
    case "yesterday": return { from: iso(shift(t, -1)), to: iso(shift(t, -1)) };
    case "this_week": return { from: iso(monday), to: iso(t) };
    case "last_week": return { from: iso(shift(monday, -7)), to: iso(shift(monday, -1)) };
    case "this_month": return { from: iso(firstOfMonth), to: iso(t) };
    case "last_month": return { from: iso(new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth() - 1, 1))), to: iso(shift(firstOfMonth, -1)) };
    case "custom": return { from: custom.from || "", to: custom.to || "" };
    default: return { from: "", to: "" };
  }
}

// The equally-long window immediately before `range`, or null when the range is open-ended.
export function previousRange(range) {
  if (!range.from || !range.to) return null;
  const from = new Date(range.from + "T00:00:00Z"), to = new Date(range.to + "T00:00:00Z");
  const days = Math.round((to - from) / 86400000) + 1;
  if (days < 1) return null;
  return { from: iso(shift(from, -days)), to: iso(shift(from, -1)) };
}

export function PeriodSelect({ value, onChange, custom, onCustomChange, testid = "period-select" }) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testid} className="rounded-sm h-9 w-40 text-xs font-mono uppercase tracking-wider"><SelectValue /></SelectTrigger>
        <SelectContent>{PERIODS.map(([k, l]) => <SelectItem key={k} value={k} data-testid={`${testid}-${k}`}>{l}</SelectItem>)}</SelectContent>
      </Select>
      {value === "custom" && (
        <>
          <DatePicker testid={`${testid}-from`} value={custom?.from || ""} onChange={(v) => onCustomChange({ ...custom, from: v })} placeholder="From" className="mt-0 h-9 w-36" />
          <span className="text-xs text-muted-foreground">–</span>
          <DatePicker testid={`${testid}-to`} value={custom?.to || ""} onChange={(v) => onCustomChange({ ...custom, to: v })} placeholder="To" className="mt-0 h-9 w-36" />
        </>
      )}
    </div>
  );
}
